import { render, staticRenderFns } from "./partnerNewsxq.vue?vue&type=template&id=743565bb&scoped=true"
import script from "./partnerNewsxq.vue?vue&type=script&lang=js"
export * from "./partnerNewsxq.vue?vue&type=script&lang=js"
import style0 from "./partnerNewsxq.vue?vue&type=style&index=0&id=743565bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743565bb",
  null
  
)

export default component.exports